import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
// Straight from the module, not from the barrel: the barrel re-exports this file, and the round trip
// is a dependency cycle (import/no-cycle, an eslint ERROR that blocks any commit touching the file).
import { useAlertMessage } from './useAlertMessage';

export function useDispatchSuccessNotification() {
    const { dispatchAlert } = useAlertMessage();
    const dispatchSuccessNotification = useCallback(
        ({ message }) =>
            dispatchAlert({
                message,
                type: 'success',
            }),
        [dispatchAlert]
    );

    return { dispatchSuccessNotification };
}

export function useDispatchSuccessfullyDeletedRecord() {
    const { t } = useTranslation();
    const { dispatchSuccessNotification } = useDispatchSuccessNotification();
    // See useDispatchSuccessfullySavedRecord: the sentence was hardcoded German in an app with an
    // EN/DE switcher. The record name stays as the caller wrote it (a technical label).
    const dispatchSuccessfullyDeletedRecord = useCallback(
        (recordName) =>
            dispatchSuccessNotification({ message: t('notification.recordDeleted', { record: recordName }) }),
        [dispatchSuccessNotification, t]
    );

    return { dispatchSuccessfullyDeletedRecord };
}
